import React from "react";

function formatDate(value) {
  if (!value) return "Not provided";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not provided";
  return date.toLocaleDateString();
}

function displayNameFor(user) {
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  return user.display_name || fullName || user.username || user.email || "Portal user";
}

export default function AccountCard({ user = {} }) {
  return (
    <div className="settings-card">
      <h3>Account</h3>

      <div className="row">
        <span>Name</span>
        <strong>{displayNameFor(user)}</strong>
      </div>

      <div className="row">
        <span>Email</span>
        <strong>{user.email || "Not provided"}</strong>
      </div>

      <div className="row">
        <span>User ID</span>
        <strong>{user.user_id || user.id || "Not available"}</strong>
      </div>

      <div className="row">
        <span>Joined</span>
        <strong>{formatDate(user.created_at || user.date_joined)}</strong>
      </div>
    </div>
  );
}